import React from "react";

export default ({ width = 55, height = 88, ...props }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 11 37" fill="none">
      <path
        d="M7.07891 1.92383H1.96525C1.48542 1.92383 1.0957 2.31355 1.0957 2.79338V10.1305C1.0957 10.6103 1.48542 11 1.96525 11H7.07891C7.55874 11 7.94846 10.6103 7.94846 10.1305V2.79338C7.94621 2.31355 7.55649 1.92383 7.07891 1.92383ZM7.33797 10.1282C7.33797 10.2724 7.22083 10.3895 7.07666 10.3895H1.963C1.81882 10.3895 1.70168 10.2724 1.70168 10.1282V2.79338C1.70168 2.6492 1.81882 2.53206 1.963 2.53206H7.07666C7.22083 2.53206 7.33797 2.6492 7.33797 2.79338V10.1282Z"
        fill="currentColor"
      />
      <path
        d="M9.03399 0H3.92033C3.4405 0 3.05078 0.389719 3.05078 0.869547C3.05078 1.0385 3.18594 1.17366 3.3549 1.17366C3.52385 1.17366 3.65901 1.0385 3.65901 0.869547C3.65901 0.725374 3.77616 0.608233 3.92033 0.608233H9.03399C9.17816 0.608233 9.2953 0.725374 9.2953 0.869547V8.20663C9.2953 8.35081 9.17816 8.46795 9.03399 8.46795C8.86503 8.46795 8.72987 8.60311 8.72987 8.77207C8.72987 8.94102 8.86503 9.07618 9.03399 9.07618C9.51382 9.07618 9.90354 8.68646 9.90354 8.20663V0.869547C9.90354 0.389719 9.51382 0 9.03399 0Z"
        fill="currentColor"
      />
    </svg>
  );
};
